import { useApi } from '@gik/core/api';
import { User } from '@gik/core/models/gik/User';
import { useEffect } from 'react';

declare const window: LegacyReactWindow;

// TODO: after SPA migration move this to the root of the application
// we should use the fullstory React plugin https://www.npmjs.com/package/react-fullstory
export default function useMvcFullStory(userId: string) {
  const { data: user } = useApi<User>(userId ? `users/${userId}` : null);

  useEffect(() => {
    (function () {
      if (window.FS && user) {
        window.FS.identify(userId, {
          displayName: user.fullName,
          email: user.emailAddress,
        });
      }
    })();
  }, [user, window.FS]);
  return null;
}
